import {getQueryParameterByName} from "../getQueryParameterByName";

export const getLanguage = (): string => {
  let languageFromQuery: string | null = getQueryParameterByName("lang");

  if (languageFromQuery.length === 0) {
    return "da";
  }

  switch (languageFromQuery) {
    default:
    case 'da':
      return "da";
    case 'de':
      return "de";
    case "en":
      return "en-gb";
  }
};
